import { Drawer } from 'antd'
import { createContext, useContext } from 'react'
import { configManager } from '../../Managers/Config'
import { EventManager } from '../../Managers/Event/EventManager'
import { MergeConfigAndPropsTask } from '../../Tasks/Utils/MergeConfigAndPropsTask'
import { DrawerStore } from './Stores/DrawerStore'

export const DrawerContext = createContext()

export const createDrawerContext = ({ ...drawerProps }) => {
    // Отримуємо конфігурацію Drawer
    const drawerConfig = configManager.get('DrawerConfig', {})
    
    // Об'єднуємо конфігурацію з пропсами через MergeConfigAndPropsTask
    const mergedProps = MergeConfigAndPropsTask({
        drawerConfig,
        drawerProps,
    }) || drawerProps
    
    if (!mergedProps.template) mergedProps.template = Drawer
    if( mergedProps.isObservable === undefined ) mergedProps.isObservable = true
    
    // Створюємо тимчасовий eventManager для виконання onBeforeInit
    const tempEventManager = new EventManager()
    
    // Виконуємо всі onBeforeInit події з переданих пропсів
    if (mergedProps.eventHandlers?.onBeforeInit) {
        Object.entries(mergedProps.eventHandlers.onBeforeInit).forEach(([name, handler]) => {
            tempEventManager.on('onBeforeInit', name, handler)
        })
    }
    
    // Emit onBeforeInit події - передаємо props по ссылці для можливості змін
    tempEventManager.emit('onBeforeInit', { props: mergedProps })
    
    // Створюємо екземпляр DrawerStore
    const drawerContext = new DrawerStore(mergedProps)
    
    // Виконуємо onAfterInit події з eventManager створеного екземпляра
    drawerContext.getEventManager().emit('onAfterInit', { drawerContext })
    
    return drawerContext
}

export const useDrawerContext = () => useContext(DrawerContext)

export const DrawerContextProvider = ({ value, children }) => (
    <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>
)
